import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      ...CommonFonts.grayFont16,
    },
    value: {
      ...CommonFonts.grayFont18,
    },
    box: {
      marginBottom: theme.spacing(10),
      cursor: 'pointer',
      [theme.breakpoints.up('sm')]: {
        marginRight: theme.spacing(25),
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(7),
      },
    },
    boxWithDescription: {
      marginBottom: theme.spacing(10),
      cursor: 'pointer',
    },
    copyAction: {
      cursor: 'pointer',
      color: '#1174F2',
      fontSize: 18,
      marginLeft: theme.spacing(6),
    },
    titleText: {
      ...CommonFonts.darkFont18,
    },
    descriptionText: {
      ...CommonFonts.grayFont14,
    },
  })
);

export default useStyles;
